import { TFunction, initSagaI18n } from "@einride/saga-core"
import { PhraseInContextEditorOptions } from "i18next-phrase-in-context-editor-post-processor/dist/src/phrase"
import explore from "../../../locales/en-US/translations.json"

export const defaultNS = "explore"
export const resources = {
  en: {
    explore,
  },
} as const

export const initi18n = (phraseOptions?: PhraseInContextEditorOptions): Promise<TFunction> =>
  initSagaI18n(
    {
      defaultNS,
      ns: ["explore"],
      resources,
    },
    phraseOptions,
  )
